import { Component } from 'react'
import { SingleComment } from 'components/common'


class Comments extends Component {
    state = {
        comments: []
    }

    componentDidMount() {
        this.setState({
            comments: this.props.comments
        })

        const commentChannel = this.props.pusher.subscribe('comments');

        commentChannel.bind(`new-comment-${this.props.feedbackId}`, data => {
            this.setState({
                comments: [
                    ...this.state.comments,
                    data
                ]
            })
        })
    }

    render() {
        return this.state.comments?.length > 0 && this.state.comments?.map((i, k) => (
            <SingleComment
                id={i.id}
                key={k}
                user={i.user}
                commentDate={i.created_at}
                text={i.text}
                likesCount={i.likesCount}
                replyComment={this.props.replyComment}
                isFinished={this.props.isFinished}
            />
        ))
    }
}

export default Comments